import { useEffect, useState } from "react";
import Logo from "@Assets/images/Frame.png";

type LoaderMode = "fullscreen" | "content";

const LogoLoader = ({ mode = "fullscreen" }: { mode?: LoaderMode }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger enter transition on mount
    const id = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <>
      <div
        className={`${
          mode === "fullscreen" ? "fixed" : "absolute"
        } inset-0 z-[9999] flex items-center justify-center bg-transparent transition-opacity duration-300 ease-out ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="ll-float ll-no-motion:!animate-none">
          <img
            src={Logo}
            alt="Local Locker"
            className={`w-[160px] h-auto sm:w-[180px] md:w-[200px] transition-transform duration-500 ease-out ${
              isVisible ? "scale-100" : "scale-95"
            } ll-glow ll-no-motion:!animate-none`}
          />
        </div>
      </div>

      <style>{`
        @keyframes ll-float {
          0%, 100% { transform: translateY(0) }
          50% { transform: translateY(-6px) }
        }
        @keyframes ll-glow {
          0%, 100% { filter: drop-shadow(0 0 0 rgba(220, 38, 38, 0)); }
          50% { filter: drop-shadow(0 6px 16px rgba(220, 38, 38, 0.15)); }
        }
        .ll-float { animation: ll-float 2.8s ease-in-out infinite; }
        .ll-glow { animation: ll-glow 2.8s ease-in-out infinite; }

        @media (prefers-reduced-motion: reduce) {
          .ll-no-motion { animation: none !important; transition: none !important; }
        }
      `}</style>
    </>
  );
};

export default LogoLoader;
